import { createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { removeSharedCookie } from "../config/cookiesSettings";
import { normalizeAccessList } from "../utils/access";

export const currentTeamSlice = createSlice({
    name: "current_team",
    initialState: {
        team: {},
        isLoading: false,
        loadError: "",
        teamConflict: null,
        teamSwitch: null,
        lastLoadedPath: null,
    },
    reducers: {
        teamConflictReceived: (state, action) => {
            if (!state.teamConflict && !state.teamSwitch) state.teamConflict = action.payload;
        },
        dismissTeamConflict: (state) => {
            state.teamConflict = null;
            if (state.teamSwitch?.error) state.teamSwitch = null;
        },
        updateLastLoadedPath: (state, action) => { state.lastLoadedPath = action.payload; },
        teamSwitchStarted: (state, action) => { state.teamSwitch = { ...action.payload, error: null }; },
        teamSwitchFailed: (state, action) => { state.teamSwitch.error = action.payload; },
        resetTeamSwitch: (state) => {
            state.teamConflict = state.teamSwitch = state.lastLoadedPath = null;
        },
        updateCurrentTeam: (state, action) => {
            let new_team = action.payload;
            new_team = { ...new_team, access_list: normalizeAccessList(new_team.access_list) };
            return { ...state, team: new_team, loadError: "" };
        },
        updateTeamLoadingStage: (state, action) => {
            return { ...state, isLoading: action.payload };
        },
        clearCurrentTeamAccess: (state) => {
            return { ...state, team: {}, loadError: "" };
        },
        teamlLoadError: (state, action) => {
            let cookies = new Cookies();
            removeSharedCookie(cookies, "team_id");
            return state;
        },
        teamLoadTransientError: (state, action) => {
            return { ...state, loadError: action.payload, team: {} };
        },
    },
});

export const {
    teamConflictReceived, dismissTeamConflict, updateLastLoadedPath, teamSwitchStarted, teamSwitchFailed, resetTeamSwitch,
    updateCurrentTeam,
    updateTeamLoadingStage,
    clearCurrentTeamAccess,
    teamlLoadError,
    teamLoadTransientError,
} = currentTeamSlice.actions;

export default currentTeamSlice.reducer;
